function toggleMobileMenu() {
  document.getElementById('mobileMenu').classList.toggle('open');
}
function closeMobileMenu() {
  document.getElementById('mobileMenu').classList.remove('open');
}

function openLightbox(src, caption) {
  document.getElementById('lightboxImg').src = src;
  document.getElementById('lightboxCaption').textContent = caption || '';
  document.getElementById('lightbox').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeLightbox() {
  var lb = document.getElementById('lightbox');
  if (lb) { lb.classList.remove('open'); document.body.style.overflow = ''; }
}

function showToast(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  document.getElementById('toastMsg').textContent = msg;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2800);
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeMobileMenu();
    closeLightbox();
  }
});

/* PRODUCT VARIANT PICKER
   Handles size/color selection on product pages:
   - keeps only the clicked value highlighted per option group
   - swaps the product photo, price, and add-to-bag state to match the
     selected variant
   - not every color/size combination is an actual sellable variant (Printify
     doesn't offer every color in every size), so combinations that don't
     exist are visually greyed out and, if selected anyway, disable Add to
     Bag with an "Unavailable" label instead of silently doing nothing or
     letting the wrong item get added to the cart. Clicking a color still
     always updates the photo (using any variant with that color) so the
     picture never appears stuck. */
var bncLastChangedGroupIndex = null;

function bncGetGrids() {
  return Array.prototype.slice.call(document.querySelectorAll('.size-grid'));
}

function bncGetVariantsData() {
  var select = document.getElementById('product-variant-select');
  if (!select) return [];
  var data = [];
  for (var i = 0; i < select.options.length; i++) {
    var opt = select.options[i];
    data.push({
      values: opt.textContent.trim().split(' / '),
      id: opt.value,
      available: opt.getAttribute('data-available') === 'true',
      image: opt.getAttribute('data-image'),
      price: opt.getAttribute('data-price')
    });
  }
  return data;
}

function bncGetSelectedValues(grids) {
  return grids.map(function(grid) {
    var chosen = grid.querySelector('.size-btn.selected');
    return chosen ? chosen.getAttribute('data-value') : null;
  });
}

function bncSelectOption(radio) {
  var grids = bncGetGrids();
  var grid = radio.closest('.size-grid');
  bncLastChangedGroupIndex = grids.indexOf(grid);

  if (grid) {
    grid.querySelectorAll('.size-btn').forEach(function(btn) {
      btn.classList.remove('selected');
    });
  }
  var span = radio.nextElementSibling;
  if (span) { span.classList.add('selected'); }

  bncRefreshAvailability();
  bncSyncSelectedVariant();
}

function bncRefreshAvailability() {
  var grids = bncGetGrids();
  if (!grids.length) return;
  var variants = bncGetVariantsData();
  var selectedValues = bncGetSelectedValues(grids);

  grids.forEach(function(grid, groupIndex) {
    grid.querySelectorAll('.size-btn').forEach(function(btn) {
      var value = btn.getAttribute('data-value');
      var candidate = selectedValues.slice();
      candidate[groupIndex] = value;
      var exists = variants.some(function(v) {
        return v.values.every(function(val, i) {
          return candidate[i] === null || candidate[i] === val;
        });
      });
      btn.classList.toggle('size-btn-unavailable', !exists);
    });
  });
}

function bncSyncSelectedVariant() {
  var grids = bncGetGrids();
  if (!grids.length) return;
  var variants = bncGetVariantsData();
  var selectedValues = bncGetSelectedValues(grids);
  if (selectedValues.indexOf(null) !== -1) return;

  var select = document.getElementById('product-variant-select');
  var img = document.getElementById('product-main-image');
  var priceEl = document.getElementById('product-price');
  var submitBtn = document.getElementById('product-submit-btn');

  var matched = variants.find(function(v) {
    return v.values.every(function(val, i) { return val === selectedValues[i]; });
  });

  if (matched) {
    if (select) { select.value = matched.id; }
    if (img && matched.image) { img.src = matched.image; }
    if (priceEl && matched.price) { priceEl.textContent = matched.price; }
    if (submitBtn) {
      submitBtn.disabled = !matched.available;
      submitBtn.textContent = matched.available ? 'Add to Bag →' : 'Sold Out';
    }
    return;
  }

  // No exact variant for this combination - block the purchase but keep the
  // photo responsive to whichever value was just clicked.
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Unavailable';
  }
  if (img && bncLastChangedGroupIndex !== null) {
    var changedValue = selectedValues[bncLastChangedGroupIndex];
    var fallback = variants.find(function(v) {
      return v.values[bncLastChangedGroupIndex] === changedValue && v.image;
    });
    if (fallback) { img.src = fallback.image; }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  bncRefreshAvailability();
  bncSyncSelectedVariant();
});


/* NAV SHOP MEGA MENU - forgiving hover
   Plain CSS :hover closes the menu the instant the cursor leaves the small
   "Shop" link's box, which happens before the mouse reaches the panel below
   it - the menu snaps shut before you can click a category. This adds a
   short grace period so moving the mouse from "Shop" down into the panel
   keeps it open. */
(function() {
  var dropdown = document.querySelector('.nav-dropdown');
  if (!dropdown) return;
  var menu = dropdown.querySelector('.nav-megamenu');
  if (!menu) return;
  var closeTimer = null;

  function openMenu() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    menu.classList.add('open');
  }
  function scheduleClose() {
    if (closeTimer) { clearTimeout(closeTimer); }
    closeTimer = setTimeout(function() {
      menu.classList.remove('open');
    }, 350);
  }

  dropdown.addEventListener('mouseenter', openMenu);
  dropdown.addEventListener('mouseleave', scheduleClose);
  menu.addEventListener('mouseenter', openMenu);
  menu.addEventListener('mouseleave', scheduleClose);
  dropdown.addEventListener('focusin', openMenu);
  dropdown.addEventListener('focusout', scheduleClose);
})();
